<template>
  <div class="subscription-feature" :class="[ theme ? `theme-${theme}` : '']">
    <div class="subscription-feature__main">
      <div class="main__name">
        <p><slot name="title"></slot></p>
        <p v-if="hasMoreInformation">
          <a @click="showMoreInformation = !showMoreInformation">
            <template v-if="!showMoreInformation">
              <i class="far fa-angle-down"></i>{{ $t('label.more_info') }}
            </template>
            <template v-else>
              <i class="far fa-angle-up"></i>{{ $t('label.less') }}
            </template>
          </a>
        </p>
      </div>

      <div class="subscription-feature__more-less" :class="{ 'is-no-more-section': !hasMoreInformation }">
      </div>

      <div class="main__options">
        <slot></slot>
      </div>
    </div>
    <div class="subscription-feature__more">
      <div class="more-option-description" v-if="showMoreInformation">
        <div class="more-option-description__item">
          <slot name="more-information"></slot>
        </div>
      </div>
      <hr>
    </div>
  </div>
</template>

<script>
import SubscriptionFeatureAbstract from './cmpt-subscription-feature-abstract';

export default {
  name: 'cmpt-subscription-option',
  mixins: [SubscriptionFeatureAbstract],
  data() {
    return {
      showMoreInformation: false,
    };
  },
  computed: {
    hasMoreInformation() {
      return this.$slots['more-information'];
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ui/subscription/cmpt-subscription-option.vue